/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecordIdentity {
    getFixupPrototypeFunction() { return RecordIdentity.fixupPrototype; }

    static newInstance(model: Partial<RecordIdentity>): RecordIdentity {
        let obj = Object.assign(new RecordIdentity(), model);
        RecordIdentity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecordIdentity>): RecordIdentity {
        if (!model) return null;
        return RecordIdentity.newInstance(<RecordIdentity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecordIdentity) {
        if (!obj) return;

        models.RecordIdentity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecordIdentity): boolean {
        Object.setPrototypeOf(obj, RecordIdentity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.lastUpdate === "string") {
            this.lastUpdate = new Date(<string><any>this.lastUpdate);
        }
    }

    /**
     * Unique Identifier of the tracked item
     */
    sysId: string;

    /**
     * Last update of the tracked item
     */
    lastUpdate: Date;

    /**
     * Context of the tracked item
     */
    table: string;

}
